import queryString from "query-string";
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useHistory } from "react-router-dom";
import UserBalancesContainer from './userBalances/UserBalancesContainer';
import TabPanel from '../../elements/tab/materialTabPanel';
import UserInfo from "../../elements/account/UserInfo";
import { useTranslation } from "react-i18next";

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

import { StyledTabsBody, StyledTabsHead, StyledTabsWrapper } from '../../styles/styledTabs';
import { StyledAccountWrapper } from '../styledAccount';

const DEFAULT_TAB = "user-info";

const AccountContainer = () => {
  const { t } = useTranslation("accountPage");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "user-info": {
        return 0;
      }
      case "user-balances": {
        return 1;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <StyledAccountWrapper>
      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledTabsWrapper>
        <StyledTabsHead className="tab-head">
          <h4 className="tab-head__title">
            {t("tabs.title")}
          </h4>
          <Tabs value={queryParams?.currentTab ?? DEFAULT_TAB}
                indicatorColor="secondary"
                onChange={handleChange}
                orientation="vertical"
                className="tab-head-buttons">
            <Tab label={t("tabs.mainData")} value="user-info" />
            <Tab label={t("tabs.balances")} value="user-balances" />
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel value={tabValue} index={0}>
            <UserInfo/>
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <UserBalancesContainer/>
          </TabPanel>
        </StyledTabsBody>
      </StyledTabsWrapper>
    </StyledAccountWrapper>
  );
};

export default AccountContainer;